import { createStyles } from '@mui/styles';
import { APTheme } from '../../../core/TenantProvider/tenants';

export default (theme: APTheme) => createStyles({
    "@keyframes onloadup": {
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        }
    },
    notificationsContainer: {
        background: '#F5F5F5',
        color: '#4a4a4a',
        fontSize: 16,
        letterSpacing: '-0.5px',
        height: '100%',
        padding: '34px 35px',
        animationName: `$onload`,
        animationDuration: '0.3s',
        animationFillMode: 'both',
        animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
        '@media(max-width: 1200px)': {
            paddingLeft: 110,
        },
        '@media(max-width: 768px)': {
            padding: 30,
        },
        '@media(max-width: 480px)': {
            padding: 20,
        }
    },
    notificationsContainerContent: {
        maxWidth: '1110px',
        position: 'relative',
        height: '100%'
    },
    notificationsEmpty: {
        width: '100%',
        maxWidth: 1110,
        padding: '80px 16px',
        textAlign: 'center'
    },
    notificationsEmptyBodyContent: {
        margin: '50px 0 0',
        textAlign: 'center'
    },
    formSectionHeading: {
        lineHeight: '28px',
        marginBottom: 22
    },
    notificationsEmptyHeading: {
        marginBottom: 10
    },
    notificationsHeader: {
        width: '100%',
        marginBottom: 20,
        lineHeight: '28px',
        '& span': {
            float: 'right',
            height: '18px',
            fontFamily: 'CircularStd',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '1.13',
            color: '#2d91e9',
            paddingTop: 5,
            '& span': {
                color: '#d6d6d6',
            }
        }
    },
    notificationsList: {
        width: '100%',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.08)',
        '& .MuiList-padding': {
            paddingTop: 0,
            paddingBottom: 0,
        },
        '& .MuiListItem-root': {
            height: 71,
            backgroundColor: '#ffffff',
            'border-bottom': '1px solid rgba(45, 145, 233, 0.1)',
            '@media(max-width: 480px)': {
                height: 'auto',
                display: 'block'
            }
        },
    },
    notificationDate: {
        '& span': {
            float: 'right',
            color: '#2d91e9',
            backgroundColor: '#eaf3ff',
            borderRadius: 2,
            fontSize: '14px',
            lineHeight: '18px',
            letterSpacing: 'normal',
            padding: '3px 6px',
            '@media(max-width: 480px)': {
                float: 'none',
                display: 'inline-block'
            }
        }
    },
    unreadNotification: {
        borderLeft: '3px solid #2d91e9'
    },
    paginationBox: {
        marginTop: 30,
        '& ul': {
            justifyContent: 'center',
        },
        '& .MuiPagination-ul .MuiPaginationItem-root': {
            fontSize: '16px',
            lineHeight: '18px',
            minWidth: 32,
            height: 32,
        },
        '& .MuiPagination-ul .MuiPaginationItem-ellipsis': {
            height: 'auto',
        }
    }
});